module.exports = __webpack_public_path__ + "static/media/green-tv.daafa9ba.svg";